module.exports = __webpack_public_path__ + "img/perks_N Donation.0e95d0df.jpg";